import React from 'react';
import '../styles/pages/Career.css';

const Career = () => {
  const jobOpenings = [
    {
      title: "Graphic Designer",
      location: "Chhatarpur, M.P.",
      type: "Full-time",
      experience: "1-3 years",
      description: "Create stunning designs for print materials including flex banners, visiting cards, wedding cards, and brochures. Proficiency in Adobe Creative Suite required."
    },
    {
      title: "Printing Machine Operator",
      location: "Chhatarpur, M.P.",
      type: "Full-time",
      experience: "2-5 years",
      description: "Operate and maintain printing machines including flex printing, solvent printing, and HP latex printers. Technical knowledge of printing processes essential."
    },
    {
      title: "Sales Executive",
      location: "Chhatarpur, M.P.",
      type: "Full-time",
      experience: "1-4 years",
      description: "Handle B2B sales for printing services, client relationship management, and business development. Excellent communication skills required."
    },
    {
      title: "CNC Cutting Specialist",
      location: "Chhatarpur, M.P.",
      type: "Full-time",
      experience: "2-4 years",
      description: "Specialize in CNC cutting for wooden works and acrylic LED letters. Experience with CNC machines and precision cutting required."
    }
  ];

  return (
    <div className="career-page">
      <div className="career-hero">
        <div className="container">
          <h1>Join Our Team</h1>
          <p>Be part of India's fastest growing printing production house since 2013</p>
        </div>
      </div>

      <div className="career-content">
        <div className="container">
          <section className="why-join-us">
            <h2>Why Work at Gyaniraj Offset?</h2>
            <div className="benefits-grid">
              <div className="benefit-card">
                <h3>Growth Opportunities</h3>
                <p>Work with cutting-edge printing technology and grow your career in the printing industry</p>
              </div>
              <div className="benefit-card">
                <h3>Competitive Benefits</h3>
                <p>Attractive salary packages, performance bonuses, and comprehensive benefits</p>
              </div>
              <div className="benefit-card">
                <h3>Learning Environment</h3>
                <p>Continuous training and skill development in latest printing technologies</p>
              </div>
              <div className="benefit-card">
                <h3>Work-Life Balance</h3>
                <p>Flexible working hours from 10:00 AM to 9:00 PM with supportive team culture</p>
              </div>
            </div>
          </section>

          <section className="job-openings">
            <h2>Current Openings</h2>
            <div className="jobs-grid">
              {jobOpenings.map((job, index) => (
                <div key={index} className="job-card">
                  <h3>{job.title}</h3>
                  <div className="job-details">
                    <span className="location">{job.location}</span>
                    <span className="type">{job.type}</span>
                    <span className="experience">{job.experience}</span>
                  </div>
                  <p>{job.description}</p>
                  <button className="apply-btn">Apply Now</button>
                </div>
              ))}
            </div>
          </section>

          <section className="how-to-apply">
            <h2>How to Apply</h2>
            <div className="apply-steps">
              <div className="step">
                <h3>1. Send Your Resume</h3>
                <p>Email your updated resume to <a href="mailto:gyanirajoffset1@gmail.com">gyanirajoffset1@gmail.com</a></p>
              </div>
              <div className="step">
                <h3>2. Initial Screening</h3>
                <p>Our HR team will review your application and contact shortlisted candidates</p>
              </div>
              <div className="step">
                <h3>3. Interview Process</h3>
                <p>Technical and HR interviews will be conducted for final selection</p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Career;
